import React, { useContext, useEffect, useState } from 'react'
import { FavoriteApi } from '../../../redux/api/FavoriteApi'
import './Revelations.scss'
import { Menu, MenuItem, MenuSelectEvent, PanelBar, PanelBarItem } from '@progress/kendo-react-layout';
import { UserApi } from '../../../redux/api/UserApi';
import { Sortable, SortableItemUIProps, SortableOnDragOverEvent, SortableOnDragStartEvent } from "@progress/kendo-react-sortable";
import { Button } from "@progress/kendo-react-buttons";
import { Icon } from '@progress/kendo-react-common';
import { Offset, Popup } from '@progress/kendo-react-popup';
import { InputSuffix, TextBox } from '@progress/kendo-react-inputs';
import { IFavOrder, IFavorite } from '../../../types/Favorites/IFavorite';
import { RevUserContext } from '../../../context/UserContext';
import { useReduxDispatch, useReduxSelector } from '../../../redux/hooks';
import * as FavoriteSlice from '../../../slices/FavoriteSlice';
import { nanoid } from 'nanoid';
import { IUserProfile } from '../../../types/User/IUserProfile';
import Scrollbars from 'react-custom-scrollbars-2';
import { ReactSortable } from "react-sortablejs";
import { HeaderMenu } from '../Contacts/HeaderMenu';
import { HeaderOptions } from '../HeaderOptions';
import { MenuProps } from '../Contacts/ContactsMenu';
import { PartialSpinny } from '../../Nav/Spinny';
import { updateIframeSrc } from '../../../slices/RevelationSlice';
import { ToolProps } from '../ActivityFeed/ActivityFeed';
import { Setting } from '../../../types/Setting/Setting';
import { useNavigate } from 'react-router-dom';

export const Revelations: React.FC<ToolProps> = (mainProps) => {
    const navigate = useNavigate();
    const profile = useContext<IUserProfile>(RevUserContext)
    const sortedData = useReduxSelector((state) => state.favs.favorites);
    const dispatch = useReduxDispatch();
    const [menuProps, setMenuProps] = useState<FavMenuProps>()
    const [expanded, setExpanded] = useState<string[]>()
    const [editItem, setEditItem] = useState<{ id: number, text: string }>()
    const { data: collapsedItems } = UserApi.useGetSettingQuery(Setting.REVELATIONS_COLLAPSED_STATE)
    const [saveSetting] = UserApi.useSaveSettingMutation()
    const { data: favorites, isFetching } = FavoriteApi.useGetUserFavoritesQuery(profile.Uid)
    const [saveFavorites] = FavoriteApi.useSaveFavoriteMutation()
    const [sortFavorites] = FavoriteApi.useSortFavoriteMutation()
    const [sortFavoriteCategories] = FavoriteApi.useSortFavCategoriesMutation()
    const [deleteFavorite] = FavoriteApi.useDeleteFavoriteMutation()
    const [headerMenu, setHeaderMenu] = useState<MenuProps<HeaderOptions>>()
    //Get the categories
    const [itemsToRender, setItemsToRender] = React.useState<FavData[]>([]);

    useEffect(() => {
        if (sortedData) {
            const categoryIds = sortedData ? [...new Set(sortedData?.slice().sort((a, b) => (a.Category_Order - b.Category_Order)).map(item => item.Category_Id))] : [];
            let newRenderData = categoryIds?.map(cid => {
                let _children = sortedData.filter(f => f.Category_Id === cid).sort((a, b) => a.Order - b.Order);
                return {
                    id: cid.toString(),
                    title: `${sortedData.find(f => f.Category_Id === cid).Category_Name} (${_children.length})`,
                    imageUrl: sortedData.find(f => f.Category_Id === cid).Category_Image_Url,
                    children: _children
                } as FavData
            });
            //console.log('setItemsToRender')
            setItemsToRender(newRenderData)
            //cancel edit
            setEditItem(null)
            //console.log('useEffect sortedData setItemsToRender', newRenderData);
        }
    }, [sortedData])

    //Only set the favoirites the first time we load data
    useEffect(() => {
        console.log('UpdatingFavoriteSlice')
        //if (favorites && !sortedData?.length) {
        //Always update
        favorites && dispatch(FavoriteSlice.saveFavorites(favorites))
        //}

    }, [favorites])


    //Put the saved collapsed items into state
    useEffect(() => {

        //Sets the expanded items into local state. This is the opposite of the state saved via the API which is the ids of the COLLAPSED items
        let expandedSet = false;
        if (collapsedItems && sortedData && !expanded) {
            let collapsedArray = JSON.parse(collapsedItems.Big_String_Value) || []//["1","2","3"...]
            if (collapsedArray) {
                let distinctIds = [...new Set(sortedData.map(s => s.Category_Id.toString()))]
                let expanded = distinctIds.filter(c => collapsedArray.indexOf(c.toString()) === -1);
                // console.log('collapsedItems', collapsedItems)
                // console.log('expanded', expanded)
                // console.log('collapsedArray', collapsedArray)
                // console.log('distinctIds', distinctIds)
                // console.log('collapsedArray.indexOf ', distinctIds.map(c => collapsedArray.indexOf(c.toString())))
                setExpanded(expanded);
                expandedSet = true;
            }
        }
        //console.log('setExpanded2', expanded, expandedSet, collapsedItems)
    }, [collapsedItems, sortedData])

    const headerRef = React.useRef<HTMLButtonElement>();

    const loadRevPage = (fav, deeplink) => {
        let relativeURL = `${fav.Url_Format.replace('{0}', fav.Key_Value_1 || '').replace('{1}', fav.Key_Value_2 || '').replace('{2}', fav.Key_Value_3 || '').replace('{3}', fav.Key_Value_4 || '').replace('{4}', fav.Key_Value_5 || '').replace('{5}', fav.Key_Value_6 || '').replace('{6}', fav.Key_Value_7 || '').replace('{7}', fav.Key_Value_8 || '')}`
        console.log('loading fav:', relativeURL, fav)
        let navigateTo = `${relativeURL}${relativeURL.indexOf('?') > -1 ? '&' : '?'}d=${nanoid()}`
        if (deeplink)
            return `./deeplink?url=${relativeURL}`;
        else
            return `${relativeURL}`;

        mainProps.itemSelected();
    }

    const gotoFavorite = (e, navigateTo) => {
        if (mainProps.fullScreen)
            return true;

        e.preventDefault()
        e.stopPropagation()
        navigate('/')
        dispatch(updateIframeSrc(navigateTo));

        return false;
    }


    const RenderItem = (props: SortableItemUIProps) => {
        const { attributes, dataItem, forwardRef, isActive, style } = props;
        const fav: IFavorite = dataItem;
        const [editText, setEditText] = useState<string>(editItem?.id === fav.Id ? editItem.text : '')

        return (
            <div className='item'
                {...attributes}
                ref={forwardRef}
                style={{
                    ...style,
                    cursor: 'default'
                    // border: isActive ? "1px dashed black" : 0
                }}>
                <div className='flex move k-font-icon k-i-pan k-color-secondary my-handle' title='Reorder' />
                {editItem?.id === fav.Id
                    //Edit mode
                    ? <TextBox autoFocus value={editText} onChange={(e) => setEditText(e.value.toString())}
                        suffix={() => (
                            <InputSuffix>
                                <Button
                                    className='m-1 save-button'
                                    style={{ backgroundColor: profile?.Nav_Hex_Color, color: '#fff' }}
                                    disabled={!editText} title='Save changes' onClick={async () => {
                                        //Save changes
                                        await saveFavorites({ uid: profile.Uid, fav: { ...fav, Name: editText } });

                                        //Update the name in the main sortedData
                                        let newData = [...sortedData]
                                        let found = newData.find(f => f.Id === fav.Id)
                                        if (found) {
                                            newData[newData.indexOf(found)] = { ...found, Name: editText }
                                            //console.log('found', newData)
                                        }
                                        dispatch(FavoriteSlice.saveFavorites(newData))

                                    }}>Save</Button>
                                <Button onClick={(e) => {
                                    e.preventDefault()
                                    e.stopPropagation()
                                    setEditItem(null)

                                }} icon='cancel' title='cancel'></Button>
                            </InputSuffix>)
                        } />
                    //Text mode
                    : <a className='link' href={loadRevPage(fav, true)} onClick={(e) => { return gotoFavorite(e, loadRevPage(fav, false)); }}>{fav.Name}</a>

                }
                {/* Menu */}
                {editItem?.id !== fav.Id &&
                    <Icon className='k-color-secondary menu' name='menu' size='small' onClick={(e) => {
                        console.log('menu clicked')
                        e.syntheticEvent.preventDefault();
                        e.syntheticEvent.stopPropagation();
                        setMenuProps(oldProps => { return { ...oldProps, item: fav, visible: !oldProps?.visible, offset: { left: e.syntheticEvent.clientX - 100, top: e.syntheticEvent.clientY + 10 } } })
                    }} ></Icon>}
            </div>
        );
    };

    //Close the menu
    const handleItemSelect = async (e) => {
        //console.log('handleItemSelect', e)
        //setMenuProps(oldProps => { return { ...oldProps, visible: false } })

        setExpanded((oldState) => {
            let newState = oldState ? [...oldState] : [];
            if (newState.indexOf(e.id.toString()) > -1)
                newState.splice(newState.indexOf(e.id.toString()), 1);
            else
                newState.push(e.id.toString())
            console.log('newState', newState)

            //Save via the API
            let newArray = itemsToRender.filter(i => newState.indexOf(i.id) === -1).map(i => i.id)
            let newSettings = { ...collapsedItems }
            newSettings.Big_String_Value = newArray.length ? `["${newArray.join('","')}"]` : null
            console.log('expanded', newArray, newSettings.Big_String_Value)
            saveSetting(newSettings);

            return newState;
        });


    }

    const menuItemSelected = async (e: MenuSelectEvent) => {
        console.log('menuItemSelected', e)
        //Delete favorite
        if (e.item.text.indexOf('Delete') > -1) {

            await deleteFavorite({ favId: menuProps.item.Id, uid: profile.Uid }).then(() => {
                //just remove the item
                let newState = [...sortedData]
                let foundItem = newState.find(n => n.Id === menuProps.item.Id)
                if (foundItem) {
                    newState.splice(newState.indexOf(foundItem), 1)
                    dispatch(FavoriteSlice.saveFavorites(newState))
                }
            }
            )

            //Update the state with new favorites
            //refetch().then((e) => dispatch(FavoriteSlice.saveFavorites(e.data)));
        } else {
            setEditItem({ id: menuProps.item.Id, text: menuProps.item.Name });
        }

        //close the popup
        setMenuProps(oldProps => { return { ...oldProps, visible: false } })
    }

    const categoryReordered = (evt, sortable) => {
        //console.log('categoryReordered', sortable)
        //update category order via the API.
        let sortArray = itemsToRender.map(i => i.id)
        sortFavoriteCategories({ order: sortArray, uid: profile.Uid })

    }

    const HeaderOptions = [
        {
            id: "win",
            title: `Open in New Window`,
            element: <button className='icon settings k-font-icon k-i-hyperlink-open' title='Open in New Window'></button>,
            link: '/Revelations',
            visible: !mainProps.fullScreen
        }
    ] as HeaderOptions[]


    return (
        <section className='revelations' onMouseLeave={mainProps.onMouseLeave} >
            <header className='right-bar-header'><img className='icon' src='./images/Revelations-Dark.png' /><span className='text'>Revelations</span>
                {!mainProps.fullScreen && <button ref={headerRef} className='icon k-font-icon k-i-more-horizontal' title='More options' onClick={(e) => {
                    setHeaderMenu((m) => { return { ...m, visible: !m?.visible, offset: { top: e.clientY + 30, left: e.clientX - 170 } } })
                }} />}
                {!mainProps.fullScreen && <button className='icon lock' onClick={mainProps.unlocked} title='Lock side-bar' ><img src='./images/Lock.png' style={{ alignContent: 'center' }} /></button>}
                {!mainProps.fullScreen && <button className='icon unlock' onClick={mainProps.locked} title='Unlock side-bar' ><img src='./images/Unlock.png' style={{ alignContent: 'center' }} /></button>}
            </header>
            <HeaderMenu {...headerMenu} options={HeaderOptions.filter(o => o.visible)} itemClicked={() => setHeaderMenu(null)} />
            {!isFetching && itemsToRender?.length == 0 && <img className='intro' src='./images/revelations_inst.png' />}
            {isFetching && !favorites ? <PartialSpinny />
                : <Scrollbars>
                    <PanelBar
                        animation={false}
                        isControlled={true}
                        className='fav-list'
                        expanded={expanded}
                    >

                        <ReactSortable list={itemsToRender} setList={setItemsToRender} onSort={categoryReordered} className='react-sorable k-panelbar' handle='.k-panelbar-item-icon'>
                            {itemsToRender?.map((c) => {
                                const onDragOver = (event: SortableOnDragOverEvent) => {
                                    let newData = [...sortedData]
                                    event.newState.map((n: IFavorite, i) => {
                                        let found = newData.find(f => n.Id === f.Id)
                                        if (found)
                                            newData[newData.indexOf(found)] = { ...found, Order: i }
                                    });
                                    dispatch(FavoriteSlice.saveFavorites(newData));

                                };
                                const Sorting = (event: SortableOnDragStartEvent) => {
                                    //No sorting when in edit mode
                                    if (menuProps?.visible || editItem)
                                        event.preventDefault()
                                }
                                const Sorted = (event: SortableOnDragOverEvent) => {
                                    console.log('sorted', c.id, event) //event.newstate
                                    const sortParams: IFavOrder = {
                                        CategoryId: parseInt(c.id),
                                        NewOrderIds: event.newState.map(i => (i as IFavorite).Id)
                                    }
                                    //Update stat via API
                                    sortFavorites({ order: sortParams, uid: profile.Uid })

                                    let newData = [...sortedData]
                                    event.newState.map((n: IFavorite, i) => {
                                        let found = newData.find(f => n.Id === f.Id)
                                        if (found)
                                            newData[newData.indexOf(found)] = { ...found, Order: i }
                                    });
                                    //console.log('dispatching', newData)
                                    dispatch(FavoriteSlice.saveFavorites(newData));
                                }
                                return (
                                    <>
                                        <PanelBarItem onSelect={handleItemSelect} expanded={expanded?.indexOf(c.id) > -1} key={c.id.toString()} id={c.id.toString()} title={`${c.title}`} imageUrl={`.${c.imageUrl}`} className="category-item k-panelbar-header">
                                            <Sortable
                                                idField={"Id"}
                                                data={c.children}
                                                itemUI={RenderItem}
                                                onDragStart={Sorting}
                                                onDragEnd={Sorted}
                                                onDragOver={onDragOver}
                                            />
                                        </PanelBarItem>
                                    </>
                                )
                            })
                            }
                        </ReactSortable>
                    </PanelBar>
                </Scrollbars>}
            {menuProps?.visible &&
                <Popup show={menuProps?.visible}
                    offset={menuProps?.offset}
                    anchorAlign={{ horizontal: 'right', vertical: 'bottom' }} className='feed-menu' collision={{ horizontal: 'fit', vertical: 'fit' }}  >
                    <Menu vertical={true} style={{ display: "inline-block" }} onSelect={menuItemSelected} openOnClick={false} hoverCloseDelay={100}  >
                        <MenuItem text="Edit item" />
                        <MenuItem text="Delete item" />
                    </Menu>
                </Popup>
            }
        </section>
    )
}
export type FavData = {
    id: string
    title: string
    imageUrl: string,
    children: IFavorite[]
}
export type FavMenuProps = {
    item: IFavorite
    visible: boolean
    offset: Offset
}

export type FavProps = {
    itemSelected?: () => void
    locked?: () => void
    unlocked?: () => void
    fullScreen?: boolean
}